import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Col, Input, Label } from 'reactstrap';

function ExpensiveReason({ requestOptions, onDataChange, disabled }) {
  const {
    control,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      quoteSelectReason: '',
      insuranceCost: '',
      insuranceComments: '',
      visaCost: '',
      visaComments: '',
      airportTransferCost: '',
      airportTransferComments: '',
    },
    mode: 'onChange',
  });

  const { headerDetails } = requestOptions || {};

  useEffect(() => {
    const subscription = watch(values => {
      onDataChange(values);
    });
    return () => subscription.unsubscribe();
  }, [watch, onDataChange]);

  useEffect(() => {
    if (headerDetails) {
      if (headerDetails?.QuoteSelectReason) {
        setValue('quoteSelectReason', headerDetails?.QuoteSelectReason);
      }
      if (headerDetails?.InsuranceCost) {
        setValue(
          'insuranceCost',
          parseFloat(headerDetails?.InsuranceQuoteCost).toFixed(2),
        );
      }
      if (headerDetails?.InsuranceComments) {
        setValue('insuranceComments', headerDetails?.InsuranceComments);
      }
      if (headerDetails?.VisaCost) {
        setValue(
          'visaCost',
          parseFloat(headerDetails?.VisaQuoteCost).toFixed(2),
        );
      }
      if (headerDetails?.VisaComments) {
        setValue('visaComments', headerDetails?.VisaComments);
      }
      if (headerDetails?.AirportTransferCost) {
        setValue(
          'airportTransferCost',
          parseFloat(headerDetails?.AirportTransferQuoteCost).toFixed(2),
        );
      }
      if (headerDetails?.AirportTransferComments) {
        setValue(
          'airportTransferComments',
          headerDetails?.AirportTransferComments,
        );
      }
    }
  }, [headerDetails, setValue]);

  return (
    <div className="ba-form">
      {headerDetails?.TravelInsurance === 'Y' && (
        <div className="d-flex flex-row align-items-center gap-2 mb-3">
          <Col>
            <Label>Travel Insurance Cost</Label>
            <Controller
              control={control}
              name="insuranceCost"
              render={({ field }) => (
                <Input
                  {...field}
                  disabled
                  className="external-filter-input"
                  type="text"
                  placeholder="Travel Insurance Cost"
                />
              )}
            />
          </Col>
          <Col>
            <Label>Travel Insurance Comments</Label>
            <Controller
              control={control}
              name="insuranceComments"
              render={({ field }) => (
                <Input
                  {...field}
                  disabled
                  className="external-filter-input"
                  type="text"
                  placeholder="Travel Insurance Comments"
                />
              )}
            />
          </Col>
        </div>
      )}
      {headerDetails?.Visa === 'Y' && (
        <div className="d-flex flex-row align-items-center gap-2 mb-3">
          <Col>
            <Label>Visa Cost</Label>
            <Controller
              control={control}
              name="visaCost"
              render={({ field }) => (
                <Input
                  {...field}
                  disabled
                  className="external-filter-input"
                  type="text"
                  placeholder="Visa Cost"
                />
              )}
            />
          </Col>
          <Col>
            <Label>Visa Comments</Label>
            <Controller
              control={control}
              name="visaComments"
              render={({ field }) => (
                <Input
                  {...field}
                  disabled
                  className="external-filter-input"
                  type="text"
                  placeholder="Visa Comments"
                />
              )}
            />
          </Col>
        </div>
      )}
      {headerDetails?.AirportTransfer === 'Y' && (
        <div className="d-flex flex-row align-items-center gap-2 mb-3">
          <Col>
            <Label>Airport Transfer Cost</Label>
            <Controller
              control={control}
              name="airportTransferCost"
              render={({ field }) => (
                <Input
                  {...field}
                  disabled
                  className="external-filter-input"
                  type="text"
                  placeholder="Airport Transfer Cost"
                />
              )}
            />
          </Col>
          <Col>
            <Label>Airport Transfer Comments</Label>
            <Controller
              control={control}
              name="airportTransferComments"
              render={({ field }) => (
                <Input
                  {...field}
                  disabled
                  className="external-filter-input"
                  type="text"
                  placeholder="Airport Transfer Comments"
                />
              )}
            />
          </Col>
        </div>
      )}

      <Col>
        <Label>Reason for not selecting cheapest option.</Label>
        <Controller
          control={control}
          name="quoteSelectReason"
          render={({ field }) => (
            <Input
              className="external-filter-input"
              {...field}
              type="textarea"
              rows={3}
              placeholder="Reason"
              disabled={disabled}
            />
          )}
        />
        {errors.quoteSelectReason && (
          <span className="text-danger">
            {errors.quoteSelectReason.message || 'Reason is required'}
          </span>
        )}
      </Col>
    </div>
  );
}

export default ExpensiveReason;
